import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import { LoggerService } from 'src/services/logger-services/logger.service';

@Pipe({
  name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {
  private readonly SafeHtmlPipeError = (error: any)=>
    `[SafeHtmlPipe] ${JSON.stringify(error)}`;
  constructor(private readonly sanitized: DomSanitizer,
    private readonly loggerService: LoggerService
  ) {}
  transform(value: any, args?: any): any {
    try{
    if (value == null || value === undefined) {
      return this.sanitized.bypassSecurityTrustHtml(''); // NOSONAR: Safe - empty string
    }

    const inputString = typeof value === 'string' ? value : String(value);
    
    // Sanitize with DOMPurify before bypassing Angular security
    const cleanHtml = DOMPurify.sanitize(inputString, {
      ALLOWED_TAGS: [
        'p', 'br', 'span', 'div',
        'b', 'strong', 'i', 'em', 'u', 's', 'mark',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'ul', 'ol', 'li',
        'a',
        'code', 'pre', 'blockquote',
        'table', 'thead', 'tbody', 'tr', 'th', 'td',
        'hr', 'img'
      ],
      ALLOWED_ATTR: [
        'class', 'href', 'target', 'rel', 'alt', 'src', 'title', 'style'
      ],
      ALLOW_DATA_ATTR: false,
      ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
    });
    
    return this.sanitized.bypassSecurityTrustHtml(cleanHtml); // NOSONAR: Safe - DOMPurify sanitized
    
    // OLD CODE (kept for rollback reference):
    // return this.sanitized.bypassSecurityTrustHtml(value);
    }
    catch(error: any){
      this.loggerService.logError(this.SafeHtmlPipeError(error), "transform")
      return '';
    }
  }

}
@Pipe({ name: 'keys',  pure: false })
export class KeyHtmlPipe implements PipeTransform {
  private readonly KeyHtmlPipeError = (error: any)=>
    `[KeyHtmlPipe] ${JSON.stringify(error)}`;
  constructor(private loggerService: LoggerService) {}
  transform(value: any, args?: any[]): any {
    try{
      if(value) {
        let keyArr: any[] = Object.keys(value),
            dataArr:any = [];
        keyArr.forEach((key: any) => {
            dataArr.push(value[key]);
        });
        return dataArr;
      }
      return [];
    }
    catch(error: any){
      this.loggerService.logError(this.KeyHtmlPipeError(error), "transform")
      return [];
    }
  }
}
@Pipe({
  name: 'split',
})
export class SplitPipe implements PipeTransform {
  private readonly SplitPipeError = (error: any)=>
    `[SplitPipe] ${JSON.stringify(error)}`;
  constructor(private loggerService: LoggerService) {}
  transform(value: string, separator: string = '##~'): string[] {
    try{
    if (!value) {
      return [];
    }
    return value.split(separator);
  }
  catch(error: any){
    this.loggerService.logError(this.SplitPipeError(error), "transform")
    return [];
  }
  }
}

@Pipe({
  name: 'refUrl',
})
export class RefUrlPipe implements PipeTransform {
  private readonly RefUrlPipeError = (error: any)=>
    `[RefUrlPipe] ${JSON.stringify(error)}`;
  constructor(private loggerService: LoggerService) {}
  transform(value: any): string[] {
    try{
    if (!value) {
      return [];
    }
    
    // Handle new format: array of strings
    if (Array.isArray(value)) {
      return value;
    }
    
    // Handle old format: string with ##~ delimiter
    if (typeof value === 'string') {
      return value.split('##~');
    }
    
    // Fallback: return empty array
    return [];
  }
  catch(error: any){
    this.loggerService.logError(this.RefUrlPipeError(error), "transform")
    return [];
  }
  }
}

@Pipe({
  name: 'attachmentName',
})
export class AttachmentNamePipe implements PipeTransform {
  private readonly AttachmentNamePipeError = (error: any)=>
    `[AttachmentNamePipe] ${JSON.stringify(error)}`;
  constructor(private loggerService: LoggerService) {}
  transform(value: any): string[] {
    try{
    if (!value) {
      return [];
    }
    
    // Handle new format: array of strings
    if (Array.isArray(value)) {
      return value;
    }
    
    // Handle old format: string with ##~ delimiter
    if (typeof value === 'string') {
      return value.split('##~');
    }
    
    // Fallback: return empty array
    return [];
  }
  catch(error: any){
    this.loggerService.logError(this.AttachmentNamePipeError(error), "transform")
    return [];
  }
  }
}
